module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921092649_T.bb94b9f8.jpg";